module.exports = __webpack_public_path__ + "static/media/logo-assembleialegislativama.bcf93d6f.png";